import React, { FunctionComponent, useState, useEffect } from "react";
import Inputs, {
  InputsGroup,
  InputLabel,
  InputImage,
} from "../../Components/Inputs";

type FormMarcaProps = {
  item: any;
  action: string;
  errors: any;
  handleOnChange: (e: any) => void;
  options?: any;
};

const FormMarca: FunctionComponent<FormMarcaProps> = ({
  item,
  action,
  errors,
  handleOnChange,
  options,
}) => {
  //const [brands, setBrands] = React.useState([])
  const [status, setStatus] = useState([]);

  useEffect(() => {
    handleStatus();
  }, []);

  const handleStatus = () => {
    const statusList: any = [
      { value: 1, text: "Activo" },
      { value: 0, text: "Inactivo" },
    ];
    setStatus(statusList);
  };

  const renderInputs = () => {
    if (action === "view") {
      return (
        <>
          <InputsGroup>
            <InputLabel label={"Marca SC"} value={item?.idMarcaSc} />
          </InputsGroup>
          <InputsGroup>
            <InputLabel label={"Alias"} value={item?.marca} />
          </InputsGroup>
          <InputsGroup>
            <InputLabel label={"Código"} value={item?.codigoMarca} />
          </InputsGroup>
          <InputsGroup>
            <InputImage label={"Logo"} id={item?.logo} value={item?.signPath} />
          </InputsGroup>
          <InputsGroup>
            <InputLabel label={"Estatus"} value={item?.estatus} />
          </InputsGroup>
        </>
      );
    } else {
      return (
        <>
          <InputsGroup>
            <>
              <Inputs
                id={"idMarcaSc"}
                label={"Marca SC"}
                type={"select"}
                value={item?.idMarcaSc}
                handleOnChange={handleOnChange}
                options={options.marcaSc}
                className={`input ${errors["idMarcaSc"] ? "input_error" : ""}`}
                errorMessage={errors["idMarcaSc"]}
                disable={item.idMarca ? true : false}
              />
              <Inputs
                id={"marca"}
                label={"Alias"}
                type={"text"}
                value={item?.marca}
                handleOnChange={handleOnChange}
                className={`input ${errors["marca"] ? "input_error" : ""}`}
                errorMessage={errors["marca"]}
                maxLength={30}
              />
            </>
          </InputsGroup>
          <InputsGroup>
            <>
              <Inputs
                id={"codigoMarca"}
                label={"Código"}
                type={"text"}
                value={item?.codigoMarca}
                handleOnChange={handleOnChange}
                className={`input ${
                  errors["codigoMarca"] ? "input_error" : ""
                }`}
                errorMessage={errors["codigoMarca"]}
                disable={item.idMarca ? true : false}
                maxLength={10}
              />
              <Inputs
                id={"logo"}
                label={"Logo"}
                type={"file"}
                value={item?.logo}
                accept={".jpeg,.jpg,.png"}
                labelPercent={25}
                handleOnChange={handleOnChange}
                className={`input ${errors["imagen"] ? "input_error" : ""}`}
                errorMessage={errors["imagen"]}
              />
              <Inputs
                id={"idEstatus"}
                label={"Estatus"}
                type={"select"}
                value={item?.idEstatus}
                handleOnChange={handleOnChange}
                options={status}
                className={`input ${errors["idEstatus"] ? "input_error" : ""}`}
                errorMessage={errors["idEstatus"]}
              />
            </>
          </InputsGroup>
        </>
      );
    }
  };

  return <>{renderInputs()}</>;
};

export default FormMarca;
